import React, { useState } from 'react';
import { Card, Table, Badge, Button } from '../ui';
import { Plus } from 'lucide-react';
export function SystemRepositoriesView() {
  const [cyclicEnabled, setCyclicEnabled] = useState(true);
  const dictionaryData = [{
    element: 'EPAY_response_code',
    code: '00',
    value: 'Success',
    description: 'Transaction approved successfully'
  }, {
    element: 'EPAY_response_code',
    code: '01',
    value: 'Refer to Card Issuer',
    description: 'Additional verification required'
  }, {
    element: 'EPAY_response_code',
    code: '51',
    value: 'Insufficient Funds',
    description: 'Account balance too low for transaction'
  }, {
    element: 'EPAY_response_code',
    code: '57',
    value: 'Blocked Account',
    description: 'Transaction not permitted for this account'
  }, {
    element: 'EPAY_response_code',
    code: '91',
    value: 'Issuer Down / Timeout',
    description: 'Bank system unavailable or timed out'
  }];
  return <div className="space-y-8" data-id="element-538">
      {/* Header */}
      <div data-id="element-539">
        <h2 className="text-3xl font-serif font-bold text-bank-navy" data-id="element-540">
          System Repositories
        </h2>
        <p className="text-lg text-slate-500 mt-2" data-id="element-541">
          Manage data dictionaries, error codes, and sequence generators.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6" data-id="element-542">
        {/* Left Column - Dictionary Element Manager */}
        <div className="lg:col-span-3" data-id="element-543">
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-544">
            <div className="px-6 py-5 border-b border-slate-100 flex justify-between items-start" data-id="element-545">
              <div data-id="element-546">
                <h3 className="text-xl font-serif font-bold text-bank-navy" data-id="element-547">
                  Dictionary Element Manager
                </h3>
                <p className="text-sm text-slate-500 mt-1" data-id="element-548">
                  Manage standardized response codes and system constants like
                  EPAY_response_code.
                </p>
              </div>
              <Button variant="primary" size="sm" className="bg-bank-navy hover:bg-bank-navy-light" leftIcon={<Plus className="h-4 w-4" data-id="element-550" />} data-id="element-549">
                Add Element
              </Button>
            </div>
            <Table data={dictionaryData} columns={[{
            header: 'ELEMENT',
            accessorKey: 'element' as const,
            className: 'font-mono text-xs text-slate-700 tracking-wider uppercase'
          }, {
            header: 'CODE',
            accessorKey: 'code' as const,
            className: 'font-mono text-xs text-slate-600 tracking-wider uppercase'
          }, {
            header: 'VALUE',
            accessorKey: 'value' as const,
            className: 'text-sm text-slate-900 font-medium tracking-wider'
          }, {
            header: 'DESCRIPTION',
            accessorKey: 'description' as const,
            className: 'text-sm text-slate-500 tracking-wider'
          }]} data-id="element-551" />
          </div>
        </div>

        {/* Right Column - RRN Sequence Configuration */}
        <div className="lg:col-span-2 space-y-6" data-id="element-552">
          <div data-id="element-553">
            <h3 className="text-xl font-serif font-bold text-bank-navy" data-id="element-554">
              RRN Sequence Configuration
            </h3>
            <p className="text-sm text-slate-500 mt-1" data-id="element-555">
              Configure Retrieval Reference Number generation algorithm.
            </p>
          </div>

          {/* RRN Generator Card */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-556">
            <div className="flex justify-between items-center mb-4" data-id="element-557">
              <h4 className="font-bold text-bank-navy" data-id="element-558">RRN Generator</h4>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800" data-id="element-559">
                Active
              </span>
            </div>

            <div className="mb-6" data-id="element-560">
              <p className="text-sm text-slate-500 mb-2" data-id="element-561">Current Value</p>
              <div className="border border-slate-200 rounded-lg px-4 py-3 bg-white" data-id="element-562">
                <span className="font-mono text-2xl font-bold text-bank-navy tracking-wider" data-id="element-563">
                  00149283
                </span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-564">
              <div data-id="element-565">
                <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-566">
                  Starting Value
                </label>
                <input type="text" value="00000001" readOnly className="w-full border border-slate-200 rounded-lg px-3 py-2 font-mono text-sm text-slate-700 bg-slate-50" data-id="element-567" />
              </div>
              <div data-id="element-568">
                <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-569">
                  Maximum Value
                </label>
                <input type="text" value="99999999" readOnly className="w-full border border-slate-200 rounded-lg px-3 py-2 font-mono text-sm text-slate-700 bg-slate-50" data-id="element-570" />
              </div>
            </div>

            <div className="flex justify-between items-center mb-6" data-id="element-571">
              <div data-id="element-572">
                <p className="font-medium text-sm text-bank-navy" data-id="element-573">
                  Cyclic Indicator
                </p>
                <p className="text-xs text-slate-500" data-id="element-574">
                  Reset to start value when max is reached
                </p>
              </div>
              <button onClick={() => setCyclicEnabled(!cyclicEnabled)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-bank-navy focus:ring-offset-2 ${cyclicEnabled ? 'bg-green-500' : 'bg-slate-200'}`} data-id="element-575">
                <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${cyclicEnabled ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-576" />
              </button>
            </div>

            <div className="space-y-3" data-id="element-577">
              <Button variant="outline" className="w-full justify-center" data-id="element-578">
                Reset to Starting Value
              </Button>
              <Button variant="primary" className="w-full justify-center bg-bank-navy hover:bg-bank-navy-light" data-id="element-579">
                Save Configuration
              </Button>
            </div>
          </div>

          {/* Message ID Sequence Card */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-580">
            <div className="flex justify-between items-center mb-4" data-id="element-581">
              <h4 className="font-bold text-bank-navy" data-id="element-582">Message ID Sequence</h4>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-583">
                Sequential
              </span>
            </div>

            <div data-id="element-584">
              <p className="text-sm text-slate-500 mb-2" data-id="element-585">Current Value</p>
              <div className="font-mono text-xl font-bold text-bank-navy tracking-wider" data-id="element-586">
                MSG-2026-8821
              </div>
              <p className="text-xs text-slate-400 mt-2" data-id="element-587">
                Format: MSG-YYYY-NNNN (auto-increments daily)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}